/**
 * Variables / components declaration for front-end.
 * @type {{showDismissibleAlert: boolean, alertVariant: string, message: string, configId: string, availableInvoiceFields: *[], invoiceFieldsToDisplay: Array}}
 */
const state = {
  showDismissibleAlert: false,
  alertVariant: '',
  message: '',
  configId: 'invoiceFieldsToDisplay',
  // hardcoded at this moment
  availableInvoiceFields: [
    {name: 'Net Amount', value: 'netAmount'},
    {name: 'Quantity', value: 'quantity'},
    {name: 'Order Type', value: 'orderType'},
    {name: 'Lens Design', value: 'lensDesign'},
    {name: 'Lens Index', value: 'lensIndex'},
    {name: 'Status', value: 'status'}],
  invoiceFieldsToDisplay: []
}
/**
 * Mutations, $store.commit call (data change).
 * @type {{updateInvoiceFieldsToDisplay: mutations.updateInvoiceFieldsToDisplay, promptDismissibleAlert: mutations.promptDismissibleAlert, closeDismissibleAlert: mutations.closeDismissibleAlert}}
 */
const mutations = {
  updateInvoiceFieldsToDisplay: function (state, newValues) {
    state.invoiceFieldsToDisplay = newValues
  },
  promptDismissibleAlert: function (state) {
    state.showDismissibleAlert = true
  },
  closeDismissibleAlert: function (state, dismiss) {
    state.showDismissibleAlert = dismiss
  }
}
/**
 * Actions, for $store.dispatch call (read data from / write data to DB).
 * @type {{initialiseConfiguration(*): void, saveInvoiceFieldsToDisplay(*=): void, resetInvoiceFieldsToDisplay(*): void}}
 */
const actions = {
  /**
   * Initialise the configurations.
   * @param context
   */
  initialiseConfiguration (context) {
    context.state.showDismissibleAlert = false
    context.state.variant = ''
    context.state.message = ''
    context.state.invoiceFieldsToDisplay = []
    let results = context.rootState.firestoreDB.collection('configuration').doc(context.state.configId)
    results.get().then(function (snapshot) {
      context.state.invoiceFieldsToDisplay = snapshot.get('configData')
    })
  },
  /**
   * Save invoiceFieldsToDisplay into database.
   * @param context
   */
  saveInvoiceFieldsToDisplay (context) {
    let saveSuccess = true
    context.state.variant = 'success'
    let docRef = context.rootState.firestoreDB.collection('configuration').doc(context.state.configId)
    context.rootState.firestoreDB.runTransaction(function (transaction) {
      return transaction.get(docRef).then(function (doc) {
        if (doc && doc.exists) {
          // update existing
          transaction.update(docRef, {
            configData: context.state.invoiceFieldsToDisplay
          })
        } else {
          // create new one if doesn't exist yet
          context.rootState.firestoreDB.collection('configuration').doc(context.state.configId).set({
            configData: context.state.invoiceFieldsToDisplay
          }).catch(function (err) {
            console.error('Error creating configuration: ' + err)
            saveSuccess = false
            context.state.message = 'Error when update: ' + err
          })
        }
      })
    }).catch(function (err) {
      console.error('Error while updating configuration: ' + err)
      saveSuccess = false
      context.state.message = 'Error when update: ' + err
    })
    if (saveSuccess) {
      context.state.alertVariant = 'success'
      context.state.message = 'Update successfully'
    } else {
      context.state.alertVariant = 'danger'
    }
    context.commit('promptDismissibleAlert')
  },
  /**
   * Reset the invoiceFieldsToDisplay.
   * @param context
   */
  resetInvoiceFieldsToDisplay (context) {
    context.dispatch('initialiseConfiguration')
  }
}

export default {namespaced: true, state, mutations, actions}



// WEBPACK FOOTER //
// ./src/store/configurationstoremodule.js